module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', {
    staticClass: "py-5"
  }, [_c('div', {
    staticClass: "mb-5",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('@/assets/img/success.svg'),
      "height": "90",
      "width": "90"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.liveClassTotalErrorExcel > 0) ? [_c('div', {
    staticClass: "font-weight-bold black--text mb-1",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.liveClassTotal - _vm.liveClassTotalErrorExcel) + "\n                    dari " + _vm._s(_vm.liveClassTotal) + " Data Telah Terupload\n                ")]), _vm._v(" "), _c('div', [_vm._v("\n                    Kami menemukan error pada berkas data Live Class.\n                    Silahkan klik edit untuk memperbaiki sesuai dengan\n                    detail kesalahan yang sudah tertera.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-7"
  }, [_c('v-btn', {
    attrs: {
      "depressed": "",
      "block": "",
      "color": "blew",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('edit')
      }
    }
  }, [_vm._v("\n                        Edit File\n                    ")])], 1)] : [_c('div', {
    staticClass: "font-weight-bold black--text mb-1"
  }, [_vm._v("\n                    Seluruh Data Telah Terupload\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-7"
  }, [_c('v-btn', {
    attrs: {
      "depressed": "",
      "block": "",
      "color": "blew",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('finish')
      }
    }
  }, [_vm._v("\n                        Selesai\n                    ")])], 1)]], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e9775eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class/components/DialogSuccessUpload.vue
// module id = 1684
// module chunks = 1